import { call, put } from "redux-saga/effects";
import { reviewService } from "../services/reviewService";
import { reviewConstants } from "../actions/constants/reviewConstants";
import { commonConstants } from "../actions/constants/commonConstants";

function* getSchoolByRatings(action:any): any {
  try {
    const response = yield call(reviewService.getSchoolByRatings, action.payload);
    if (response.success) {
        yield put({ type: reviewConstants.getSchoolByRatingsSuccess, payload: response.resultObject });
    } else {
        yield put({ type: reviewConstants.getSchoolByRatingsFailure, payload: response.errorMessage });
    }
    } catch (error) {
    yield put({ type: reviewConstants.getSchoolByRatingsFailure, payload: error });
    }
}


function* listReviews(action: any): any {
  try {
    const response = yield call(reviewService.listReviews, action.payload);
    if (response?.success) {
      yield put({ type: reviewConstants.listReviewsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: reviewConstants.listReviewsFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: reviewConstants.listReviewsFailure, payload: error });
  }
}

function* getInstructorRatings(action: any): any {
  try {
    const response = yield call(reviewService.getInstructorRatings, action.payload.instructorId);
    if (response?.success) {
      yield put({ type: reviewConstants.getInstructorRatingsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: reviewConstants.getInstructorRatingsFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: reviewConstants.getInstructorRatingsFailure, payload: error });
  }
}

function* getSchoolRatings(action: any): any {
  try {
    const response = yield call(reviewService.getSchoolRatings, action.payload);
    if (response?.success) {
      yield put({ type: reviewConstants.getSchoolRatingsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: reviewConstants.getSchoolRatingsFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: reviewConstants.getSchoolRatingsFailure, payload: error });
  }
}

function* deleteReview(action: any): any {
  try {
    const response = yield call(reviewService.deleteReview, action.payload.id);
    if (response?.success) {
      yield put({ type: reviewConstants.deleteReviewSuccess });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: reviewConstants.deleteReviewFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: reviewConstants.deleteReviewFailure, payload: error });
  }
}

function* viewReview(action: any): any {
  try {
    const response = yield call(reviewService.viewReview, action.payload.id);
    if (response?.success) {
      yield put({ type: reviewConstants.viewReviewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: reviewConstants.viewReviewFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: reviewConstants.viewReviewFailure, payload: error });
  }
}

export const reviewSaga = {
  listReviews,
  getInstructorRatings,
  getSchoolRatings,
  deleteReview,
  viewReview,
  getSchoolByRatings
};